import store from '../../store';

const sizeChange = function(){
  var htmlEl=document.documentElement;
  var momentWith=0;
  // var remScale = null;
  function setHtmlFontSize(designWidth,maxWidth){
    momentWith =  htmlEl.clientWidth>maxWidth?maxWidth:htmlEl.clientWidth;
    htmlEl.style.fontSize=momentWith/designWidth*100+'px';
    // remScale = momentWith/designWidth*100;
  }
  setHtmlFontSize(750,750);
  window.addEventListener('resize',function(){
    setHtmlFontSize(750,750);
  },false)
}

const formatDate = function(date){
  if(date==''){return '2018-01-01'}
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  return y + '-' + m + '-' + d

}

const context=function () {
  var host=window.location.hostname;
  if(host.indexOf('whp2')==-1){
    // store.state.context='http://gateway.scigeeker.com:9009/api-gzhmu';
    // store.state.context = 'http://gateway.demo.scigeeker.com/gzhmutestsystem/gzhmu';
    store.state.context = 'http://gateway.demo.scigeeker.com/rmsapi/';
  }else {
    store.state.context='https://whp5.gzhmu.edu.cn/gzhmu-WebApi/gzhmu';
  }
  // store.state.context='https://whp5.gzhmu.edu.cn/gzhmu-WebApi/gzhmu';
  // store.state.context='https://whp5.gzhmu.edu.cn/api-gzhmu';
  // store.state.context = 'http://gateway.demo.scigeeker.com/gzhmutestsystem';
  // store.state.context = 'http://gateway.demo.scigeeker.com/gzhmutestsystem/gzhmu';
  // store.state.context = 'http://localhost:9040/gzhmu';
}

const getParam = function (name) {
  var search = document.location.search;
  var pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
  var matcher = pattern.exec(search);
  var items = null;
  if (null != matcher) {
    try {
      items = decodeURIComponent(decodeURIComponent(matcher[1]));
    } catch (e) {
      try {
        items = decodeURIComponent(matcher[1]);
      } catch (e) {
        items = matcher[1];
      }
    }
  }
  return items;
};
//给试剂加上规格和纯度
const reagentName =function (data,type) {
  let dataLen=data.length;
  switch (type){
    case 1:
      for (let i=0;i<dataLen;i++){
        traversingJson(data[i]);
        if(data[i].itemName!='--'){
          // 如果规格和生产厂家有一个是空显示都会不一样
          if(data[i].size!='--' && data[i].unit!='--' && data[i].purity!='--'){
            data[i].fullName=data[i].itemName+'('+data[i].size+data[i].unit+'，'+data[i].purity+')';
          }else if(data[i].size!='--' && data[i].unit!='--' && data[i].purity=='--'){
            data[i].fullName=data[i].itemName+'('+data[i].size+data[i].unit+')';
          }else if((data[i].size=='--' || data[i].unit=='--') && data[i].purity!='--'){
            data[i].fullName=data[i].itemName+'('+data[i].purity+')';
          }else {
            data[i].fullName=data[i].itemName;
          }
        }
      }
      break
    case 2:
      for (let i=0;i<dataLen;i++){
        for(let j=0;j<data[i].value.length;j++){
          traversingJson(data[i].value[j]);
          if(data[i].value[j].itemName!='--'){
            // 如果规格和生产厂家有一个是空显示都会不一样
            if(data[i].value[j].size!='--' && data[i].value[j].unit!='--' && data[i].value[j].purity!='--'){
              data[i].value[j].fullName=data[i].value[j].itemName+'('+data[i].value[j].size+data[i].value[j].unit+'，'+data[i].value[j].purity+')';
            }else if(data[i].value[j].size!='--' && data[i].value[j].unit!='--' && data[i].value[j].purity=='--'){
              data[i].value[j].fullName=data[i].value[j].itemName+'('+data[i].value[j].size+data[i].value[j].unit+')';
            }else if((data[i].Value[j].size=='--' && data[i].value[j].unit=='--') && data[i].value[j].purity!='--'){
              data[i].value[j].fullName=data[i].value[j].itemName+'('+data[i].value[j].purity+')';
            }else {
              data[i].value[j].fullName=data[i].value[j].itemName;
            }
          }
        }
      }
      break;
  }
  return data;
}
const traversingJson=function (jsonData) {
  for(var key in jsonData){
    if(jsonData[key]!==0){
      if(jsonData[key]==='' || jsonData[key]===null){
        jsonData[key]='--';
      }
    }
  }
}
const getPermissions=(code,data)=>{
  let permissions=[];
  for(let v of data){
    if(v.code==code){
      for(let c of v.data){
         permissions.push(c.code);
      }
    }
  }
  return permissions;
}
export {formatDate,sizeChange,context,getParam,reagentName,traversingJson,getPermissions}





// WEBPACK FOOTER //
// ./src/assets/js/common.js